<template>
    <div class="i-Scroll-To"></div>
</template>

<script>
//import throttle from 'throttle-debounce/throttle'
import { throttle } from 'throttle-debounce'
const cubic = value => Math.pow(value, 3)
const easeInOutCubic = value => value < 0.5
    ? cubic(value * 2) / 2
    : 1 - cubic((1 - value) * 2) / 2

const emptyFn = () => {}

export default {
    name: 'ScrollTo',
    props: {
        target: {
            type: String,
            default: ''
        },
        listenScroll: {
            type: Boolean,
            default: false
        },
        handler: {
            type: Function,
            default: emptyFn
        }
    },
    data() {
        return {
            el: null,
            container: null
        }
    },
    created() {
        if (this.listenScroll && this.handler === emptyFn) {
            throw new Error('expect handler attribute')
        } else if (!this.listenScroll && this.handler !== emptyFn) {
            throw new Error('expect listenScroll attribute to be true')
        }
    },
    mounted() {
        this.init()
        if (!this.listenScroll) return
        this.throttledScrollHandler = throttle(300, this.onScroll)
        this.container.addEventListener('scroll', this.throttledScrollHandler)
    },
    beforeDestroy() {
        this.container.removeEventListener('scroll', this.throttledScrollHandler)
    },
    methods: {
        init() {
            this.container = document
            this.el = document.documentElement
            if (this.target) {
                this.el = document.querySelector(this.target)
                if (!this.el) {
                    throw new Error(`target is not existed: ${this.target}`)
                }
                this.container = this.el
            }
        },
        onScroll() {
            this.handler && this.handler()
        },
        scrollToTop(fn) {
            this.scrollTo(0, fn)
        },
        scrollTo(distance, fn) {
            this.cb = fn
            const el = this.el
            const beginTime = Date.now()
            const beginValue = el.scrollTop
            const interval = Math.abs(beginValue - distance)
            const isUp = distance < beginValue
            const rAF = window.requestAnimationFrame || (func => setTimeout(func, 16))
            const frameFunc = () => {
                const progress = (Date.now() - beginTime) / 500
                if (progress < 1) {
                    if (isUp) {
                        // 向上 -
                        el.scrollTop = (
                            beginValue - (interval * (easeInOutCubic(progress))) 
                        )
                    } else {
                        // 向下 +
                        el.scrollTop = (
                            beginValue + (interval * (easeInOutCubic(progress))) 
                        )
                    }
                    rAF(frameFunc)
                } else {
                    el.scrollTop = distance
                    this.cb && this.cb()
                    this.$emit('reach')
                }
            }
            rAF(frameFunc)
        }
    }
}
</script>
